var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultImg = function SvgDefaultImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 176 176"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h176v176H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F6FA",
    fillRule: "evenodd",
    d: "M90.805 67.641a5.64 5.64 0 1 1-11.281 0 5.64 5.64 0 0 1 11.281 0M73.282 85.405A5.641 5.641 0 1 1 62 85.403a5.641 5.641 0 0 1 11.282.002m-5.701 18.085v11.478c26.066 0 47.266-21.204 47.266-47.267H103.37c0 19.734-16.055 35.789-35.789 35.789",
    clipRule: "evenodd"
  })));
};
export default SvgDefaultImg;